export default __webpack_public_path__ + "static/media/shopping-cart.e7447698.svg";